import {Product} from "./product";

export class Like {
  public productId: string;
  public variantId: string;
  public product: Product;

  constructor(productId: string, variantId: string, product?: Product) {
    this.productId = productId;
    this.variantId = variantId;
    this.product = product ? new Product(product) : null
  }
}